import Vue from 'vue'
import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import mixin from '@/mixins'
import storage from '@/utils/storage'
import '@/utils/globalComponents'
import 'windi.css'
import '@/filter/index'
import '@/utils/prop'
import '@/icons'
import Print from './utils/print'

Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$storage = storage
Vue.use(Print)
// 导入element ui
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/element-variables.scss'
import '@/assets/style/index.scss'

import locale from 'element-ui/lib/locale/lang/en'

import elTableInfiniteScroll from 'el-table-infinite-scroll'
Vue.use(elTableInfiniteScroll)

Vue.use(Element, {
  locale
})

// 加载全局组件
import dictView from '@/components/dict-view'
Vue.component('dictView', dictView)

// 自定义属性
import directive from '@/directive/'
Vue.use(directive)

// 剪切板复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// import signalR from '@/utils/signalR'
// signalR.init(process.env.VUE_APP_SOCKET)
// Vue.prototype.$signalr = signalR
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.prototype.$global = {}

// 通用方法
import { download } from '@/utils/tools'

import 'windi.css'
Vue.prototype.download = download

Vue.mixin(mixin)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
